import React from "react"
import PropTypes from "prop-types"

const FloatingButton = ({
  label = "Ver más",
  iconClassName = "pi pi-angle-down",
  onClick = () => {},
  visible = false,
}) => {
  if (!visible) {
    return null
  }
  return (
    <div className="floating-button" onClick={onClick}>
      <span>{label}</span>
      <i className={iconClassName} />
    </div>
  )
}

export default FloatingButton

FloatingButton.propTypes = {
  label: PropTypes.string,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  visible: PropTypes.bool.isRequired,
}
